import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { X } from "lucide-react";

// Strictly-necessary cookie info banner. GDPR/ePrivacy allows functional auth cookies
// without consent, but informing the user is best practice.
export default function CookieBanner({ lang = "no" }) {
  const [shown, setShown] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const seen = localStorage.getItem("cbt-cookie-info-seen");
    if (!seen) setShown(true);
  }, []);

  const dismiss = () => {
    localStorage.setItem("cbt-cookie-info-seen", "1");
    setShown(false);
  };

  if (!shown) return null;
  // Kiosk / office TV screen must never show consent overlays.
  const path = location?.pathname || "";
  if (path === "/tv-dashboard" || path === "/skjerm") return null;
  // Internal (post-login) routes have implicit consent for functional
  // cookies – no need to keep the banner blocking action buttons.
  if (path.startsWith("/admin") || path.startsWith("/service") ||
      path.startsWith("/vask") || path.startsWith("/portal") ||
      path.startsWith("/profile") || path.startsWith("/incidents")) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:max-w-md z-[100] bg-[#0C1824] text-white rounded-xl shadow-2xl p-4 border border-[#BD984D]/40"
    >
      <div className="flex items-start gap-3">
        <div className="flex-1 text-sm leading-relaxed">
          {lang === "en" ? (
            <>
              We use strictly necessary cookies for login. No tracking or marketing
              cookies are used. See our{" "}
              <Link to="/personvern" className="text-[#ECC974] underline">
                privacy policy
              </Link>.
            </>
          ) : (
            <>
              Vi bruker kun nødvendige cookies for innlogging. Ingen sporing eller
              markedsføring. Les{" "}
              <Link to="/personvern" className="text-[#ECC974] underline">
                personvernerklæringen
              </Link>.
            </>
          )}
        </div>
        <button
          onClick={dismiss}
          data-testid="cookie-banner-close"
          aria-label="Lukk"
          className="text-white/70 hover:text-white p-1 -m-1 flex-shrink-0"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
      <button
        onClick={dismiss}
        data-testid="cookie-banner-ok"
        className="mt-3 w-full bg-[#BD984D] hover:bg-[#A57F39] text-[#0C1824] font-semibold py-2 rounded-lg text-sm"
      >
        {lang === "en" ? "Got it" : "OK, forstått"}
      </button>
    </div>
  );
}
